// extracted by mini-css-extract-plugin
export default {"snippet":"CqCtElJL","reactions":"nrOUsoSO","mobile":"mobile"};